import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled, { withTheme } from "styled-components/macro";
import "./appbar.css";
import { SmartToaster, toast } from "react-smart-toaster";
import { Grid, Hidden, AppBar as MuiAppBar, IconButton as MuiIconButton, Toolbar } from "@mui/material";
import { AddModeratorOutlined, DirectionsCarFilledOutlined, Menu as MenuIcon } from "@mui/icons-material";
import NotificationsCommon from "./NotificationsCommon";
import { DollarSign, Home, List, Menu, PieChart, Power, Smartphone, Tool, Users } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const AppBarComponent = ({ onDrawerToggle }) => {
  const { user, isAuthenticated } = useAuth0();
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    let menuListTemp = [];
    if (isAuthenticated) {
      if (user['https://propertydek.com/permissions'].indexOf('dashboard:read') > -1) {
        menuListTemp.push({
          title: 'Dashboard',
          icon: <PieChart />,
          path: "/dashboard"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('property:read') > -1) {
        menuListTemp.push({
          title: 'Properties',
          icon: <Home />,
          path: "/properties/list"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('tenant:read') > -1) {
        menuListTemp.push({
          title: 'People',
          icon: <Users />,
          path: "/people/tenants"
        });
      } else if (user['https://propertydek.com/permissions'].indexOf('prospect:read') > -1) {
        menuListTemp.push({
          title: 'People',
          icon: <Users />,
          path: "/people/prospects"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('device:read') > -1) {
        menuListTemp.push({
          title: 'Devices',
          icon: <Smartphone />,
          path: "/smart-devices/list"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('request:read') > -1) {
        menuListTemp.push({
          title: 'Maintenance',
          icon: <Tool />,
          path: "/maintenance/request"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('task:read') > -1) {
        menuListTemp.push({
          title: 'Tasks',
          icon: <List />,
          path: "/request/tasks"
        });
      } else if (user['https://propertydek.com/permissions'].indexOf('task-checklist:read') > -1) {
        menuListTemp.push({
          title: 'Tasks',
          icon: <List />,
          path: "/request/task-list"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('income:read') > -1) {
        menuListTemp.push({
          title: 'Income',
          icon: <DollarSign />,
          path: "/income/all-income"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('vehicle:read') > -1) {
        menuListTemp.push({
          title: 'Vehicles',
          icon: <DirectionsCarFilledOutlined />,
          path: "/security/vehicle/list"
        });
      }
      if (user['https://propertydek.com/permissions'].indexOf('journal:read') > -1) {
        menuListTemp.push({
          title: 'Journals',
          icon: <AddModeratorOutlined />,
          path: "/security/journal/list"
        });
      }
    }

    if (menuListTemp.length < 4) {
      menuListTemp.push({
        title: 'Logout',
        icon: <Power />,
        path: "/logout"
      });
    } else {
      menuListTemp = menuListTemp.slice(0, 4);
      menuListTemp.push({
        title: 'More',
        icon: <Menu />,
        path: "/more"
      });
    }

    setMenuList(menuListTemp);
  }, [user, isAuthenticated]);

  return (<>
    <AppBar position="sticky" elevation={0} className="TopHeader">
      <Toolbar className="toolbarPadding">
        <Grid container alignItems="center">
          <Hidden mdUp>
            <Grid item>
              <IconButton color="inherit" aria-label="Open drawer" onClick={onDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </Grid>
          </Hidden>
          <Grid item>
            <Link to={"/"}>{" "}<img className="appLogo" src="/static/img/logo.svg" alt="logo" /></Link>
          </Grid>
          <Grid item xs />
          <Grid item>
            {/* <MessagesDropdown /> */}
            <NotificationsCommon />
          </Grid>
        </Grid>

      </Toolbar>
    </AppBar>

    {/*(localStorage.getItem("pdUserRole") && localStorage.getItem("pdUserRole") === 'Technician') && <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }} className="MobileHeader">
      <Link className="MobileMenuLink" to={"/maintenance/request"}><Tool /><span>Requests</span></Link>
      <Link className="MobileMenuLink" to={"/request/task-list"}><div style={{ WebkitMask: `url(/static/img/tasklist.svg) no-repeat center / contain` }}></div><span>Task Lists</span></Link>
      <Link className="MobileMenuLink" to={"/logout"}><Power /><span>Logout</span></Link>
    </AppBar>}

    {(localStorage.getItem("pdUserRole") && localStorage.getItem("pdUserRole") === 'Security') && <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }} className="MobileHeader">
      <Link className="MobileMenuLink" to={"/security/journal/list"}><Shield /><span>Journals</span></Link>
      <Link className="MobileMenuLink" to={"/security/vehicle/list"}><DirectionsCarFilledOutlined /><span>Vehicles</span></Link>
      <Link className="MobileMenuLink" to={"/pet/list"}><PetsOutlinedIcon /><span>Pets</span></Link>
      <Link className="MobileMenuLink" to={"/logout"}><Power /><span>Logout</span></Link>
    </AppBar>}

    {(localStorage.getItem("pdUserRole") && localStorage.getItem("pdUserRole") === 'Other') && <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }} className="MobileHeader">
      <Link className="MobileMenuLink" to={"/dashboard"}><PieChart /><span>Dashboard</span></Link>
      <Link className="MobileMenuLink" to={"/properties/list"}><Home /><span>Properties</span></Link>
      <Link className="MobileMenuLink" to={"/people/tenants"}><Users /><span>People</span></Link>
      <Link className="MobileMenuLink" to={"/smart-devices/list"}><Smartphone /><span>Devices</span></Link>
      <Link className="MobileMenuLink" to={"/more"}><Menu /><span>More</span></Link>
    </AppBar>*/}

    <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }} className="MobileHeader">
      {menuList?.map(i => {
        return <Link className="MobileMenuLink" to={i?.path}>{i?.icon}<span>{i?.title}</span></Link>
      })}
    </AppBar>

    <SmartToaster
      store={toast}
      lightBackground={true}
      position={"top_center"}
    />

  </>);
};

export default withTheme(AppBarComponent);